import { useAuth } from '../hooks/useAuth.jsx';

/**
 * Top bar: brand, last data session and the account controls.
 *
 * @param {{asOf?: string | null, onRequestSignIn: () => void}} props
 */
export default function Navbar({ asOf, onRequestSignIn }) {
  const { user, ready, signOut, isConfigured } = useAuth();

  return (
    <header className="sticky top-0 z-30 border-b border-terminal-700 bg-terminal-950/85 backdrop-blur">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-4 py-3">
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg border border-bull/40 bg-bull/10 font-mono text-sm font-bold text-bull">
            NS
          </span>
          <div className="leading-tight">
            <h1 className="font-semibold tracking-wide text-slate-100">NiftySense</h1>
            <p className="text-[11px] uppercase tracking-[0.18em] text-slate-500">
              NIFTY 50 Bull Score terminal
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          {asOf ? (
            <span className="hidden font-mono text-[11px] text-slate-500 sm:inline">
              data&nbsp;as&nbsp;of {asOf}
            </span>
          ) : null}

          {!isConfigured ? (
            <span className="pill border-caution/40 bg-caution/10 text-caution">auth off</span>
          ) : !ready ? (
            <span className="text-xs text-slate-500">…</span>
          ) : user ? (
            <>
              <span className="hidden max-w-[14rem] truncate text-xs text-slate-400 sm:inline">
                {user.email}
              </span>
              <button type="button" className="btn-ghost" onClick={() => signOut()}>
                Sign out
              </button>
            </>
          ) : (
            <button type="button" className="btn-primary" onClick={onRequestSignIn}>
              Sign in
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
